module.exports = __webpack_public_path__ + "img/9788981337674.27eaeefa.jpg";